import Text from 'components/Text/Text';
import React from 'react';
import { IItemDishesForPagination } from 'types';
import moment from 'moment';
import style from './AdditionallyInfoView.module.scss';

interface IAdditionallyInfoView {
	data: IItemDishesForPagination;
}

const AdditionallyInfoView: React.FC<IAdditionallyInfoView> = ({
	data: { insertedDate, insertedBy, updatedDate, updatedBy },
}) => {
	return (
		<div className={style.infoContainer}>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="createdLabel"
					theme="neutralLight"
				/>
				{insertedDate ? (
					<Text
						className={style.blockValue}
						translationNameSpace="listing"
						translationKey="createdString"
						components={[<span key="1" className={style.date} />]}
						values={{
							createdAt: moment(insertedDate).format('MM/DD/YYYY h:mm:ss A'),
							createdBy: insertedBy,
						}}
					/>
				) : (
					'-'
				)}
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="lastUpdateLabel"
					theme="neutralLight"
				/>
				{updatedDate ? (
					<Text
						className={style.blockValue}
						translationNameSpace="listing"
						translationKey="updatedString"
						components={[<span key="1" className={style.date} />]}
						values={{
							updatedAt: moment(updatedDate).format('MM/DD/YYYY h:mm:ss A'),
							updatedBy: updatedBy,
						}}
					/>
				) : (
					'-'
				)}
			</div>
		</div>
	);
};

export default AdditionallyInfoView;
